import {KeywordTypes} from '@/api/keywordApi';
import {getKeywordType} from '@/api/keywordApi/utils';
import {useKeywordData} from '@/modules/common/hooks/useKeywordData';
import {useSearchParams} from '@/modules/common/hooks/useSearchParams';

export const useDestination = () => {
  const [searchParams] = useSearchParams();
  const destinationId = searchParams.destinationId || '';
  const destinationKeywordResponse = useKeywordData(destinationId);
  const parentDestinationKeywordResponse = useKeywordData(
    destinationKeywordResponse.data?.type === KeywordTypes.hotel
      ? (destinationKeywordResponse.data.meta?.parentId as string) || ''
      : ''
  );

  return {
    id: destinationId,
    type: getKeywordType(destinationId),
    keyword: destinationKeywordResponse.data,
    parentKeyword: parentDestinationKeywordResponse.data,
  };
};
